import React from 'react';
import { isMobileOnly } from 'react-device-detect';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import logo from '../../img/logo_white.png';
import Button from '../common/Button';
import { termsAndConditions } from '../../data';

function TermsAndConditionsPage({ onClick, acceptedDate }) {
  const { t } = useTranslation();

  const btnClass = isMobileOnly ? 'btn-block fixed-bottom' : 'min-width';
  function AcceptButton() {
    return (
      <Button
        label={t('termsAndConditions.accept')}
        name="accept"
        onClick={onClick}
        cssClass={`btn ${btnClass}`}
        title={t('termsAndConditions.tooltip')}
      />
    );
  }

  return (
    <div className="startpage-container">
      <div className="container mb-5">
        <div className="text-center">
          <img src={logo} className="my-4 img-fluid medel-logo" alt="MED-EL Logo" />
        </div>
        <p className="terms-heading">{t('termsAndConditions.title')}</p>
        <p className="text-small">{termsAndConditions.version}</p>
        <p>
          {t('termsAndConditions.body')}
        </p>
        <p>
          {t('termsAndConditions.bodyNote')}
        </p>
        {acceptedDate !== null && (
          <p>{`${t('termsAndConditions.AcceptedAt')} ${acceptedDate.toLocaleDateString()}`}</p>
        )}
      </div>
      {isMobileOnly ? (<AcceptButton />) : (
        <div className="d-flex justify-content-center"><AcceptButton /></div>
      )}
    </div>
  );
}

TermsAndConditionsPage.propTypes = {
  onClick: PropTypes.func.isRequired,
  acceptedDate: PropTypes.instanceOf(Date),
};

TermsAndConditionsPage.defaultProps = {
  acceptedDate: null,
};

export default TermsAndConditionsPage;
